export default __webpack_public_path__ + "static/media/Calc.e2634c48.png";